const toDecimalFormat = (string: string) => parseFloat(string || '0').toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 0 });

export default {
  types: {
    _increment: {
      name: 'ลำดับ',
      width: '3rem',
      class: 'text-center',
    },
    avatarUrl: {
      name: '',
      width: '3rem',
      class: 'text-center',
    },
    license: {
      name: 'ทะเบียนรถ',
      width: '8rem',
    },
    defaultDriver: {
      name: 'คนขับ (ตั้งต้น)',
      width: '12rem',
      class: 'text-left',
      filter: (val: any) => `${val?.name || ''}`,
    },
    model: {
      name: 'รุ่นรถ',
      width: '10rem',
    },
    mile: {
      name: 'ระยะทางที่วิ่ง',
      width: '7rem',
      filter: (val: string, row: any) => `${toDecimalFormat(val || '0')}`,
      class: 'text-right',
    },
    maxWeight: {
      name: 'น้ำหนักสูงสุด / ตามกฎหมาย',
      width: '12rem',
      class: 'text-center',
      filter: (val: string, row: any) => `${toDecimalFormat(row.item?.maxWeight || 0)} / ${toDecimalFormat(row.item.legalWeight || 0)}`,
    },
  },
  sortable: [
    'mile',
    'license',
    'model',
  ],
  search: {
  },
  columns: [
  ],
  grids: [
  ],
};
